module.exports = __webpack_public_path__ + "img/svg-copyright.5e676559.svg";